<template>
  <th class="text-center">
    <v-select
      class="select"
      :items="variants"
      item-value="name"
      item-text="name"
      label=""
      style="max-width: 60px; font-size: 11px"
      dense
      hide-details
      :menu-props="{
        bottom: true,
        offsetY: true,
        fontSize: 11,
        minWidth: 75,
        transition: 'scale-transition',
      }"
      single-line
      @change="changed"
      v-model="selected"
    >
    </v-select>
  </th>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    num: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selected: "",
      variants: [
        { id: 0, name: "" },
        { id: 1, name: "1:0" },
        { id: 2, name: "0:1" },
        { id: 3, name: "1:0 B" },
        { id: 4, name: "0:1 B" },
        { id: 6, name: "1:0 R" },
        { id: 7, name: "0:1 R" },
        { id: 8, name: "1:0 F" },
        { id: 9, name: "0:1 F" },
      ],
    };
  },
  methods: {
    // ...mapMutations(["deleteFilterKey", "setFilterKey"]),
    ...mapActions(["deleteFilterKey", "setFilterKey"]),
    ...mapGetters(["getSettings"]),
    clear() {
      this.selected = "";
      this.$emit("filter_update");
    },

    setSelected(value) {
      // console.log("Setting selected: " + value);
      this.selected = value;
    },
    changed: function () {
      let key = "";
      if (this.selected == null || this.selected == "") {
        let key_to_delete = "rounds_view__" + this.num + "_view";
        this.deleteFilterKey({ key_to_delete });
        key_to_delete = "rounds_view_f__" + this.num + "_view_f";
        this.deleteFilterKey({ key_to_delete });
        this.$emit("filter_update");
        return;
      }

      // console.log("Changed:" + this.selected, "Side:" + this.num);
      // console.log("Len: " + this.selected.length);
      if (this.selected.length == 3) {
        key = "rounds_view__" + this.num + "_view";
        let key_to_delete = "rounds_view_f__" + this.num + "_view_f";
        this.deleteFilterKey({ key_to_delete });
      } else {
        key = "rounds_view_f__" + this.num + "_view_f";
        let key_to_delete = "rounds_view__" + this.num + "_view";
        this.deleteFilterKey({ key_to_delete });
      }
      let value = this.selected;
      // console.log("Selected: " + value);
      this.setFilterKey({ key, value });
      this.$emit("filter_update");
    },
    findValueByPrefix: function (object, prefix) {
      for (var property in object) {
        if (
          Object.prototype.hasOwnProperty.call(object, property) &&
          property.toString().startsWith(prefix)
        ) {
          return [property, object[property]];
        }
      }
    },
  },
  created() {
    var entity = "rounds_view__";
    // console.log("Entity + name = " + entity + this.num);
    var prefix = entity + this.num;
    var settings = this.getSettings().filters;
    var result = this.findValueByPrefix(settings, prefix);
    if (result) {
      // console.log("KEY: " + key + " VALUE: " + value);
      var value = result[1];
      this.selected = value;
      return;
    } else {
      entity = "rounds_view_f__";
      // console.log("Entity + name = " + entity + this.num);
      prefix = entity + this.num;
      settings = this.getSettings().filters;
      result = this.findValueByPrefix(settings, prefix);
      if (!result) return;
      value = result[1];
      // console.log("KEY: " + key + " VALUE: " + value);
      this.selected = value;
    }
    // this.selected = this.getSettings().filters[this.entity + this.name];
    // this.selectedMultiple = this.getSettings().filters[this.entity + this.name];
  },
};
</script>

<style scoped>
.select {
  padding-right: 0px;
}
</style>
